import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContactsService {

  constructor(private api: ApiService) { }

  getAllContacts(data: any): Observable<any> {
    return this.api.post(environment.getAllContactWithCount, data);
  }

  deleteContact(data: any): Observable<any> {
    return this.api.post(environment.deleteContact, data);
  }

  createContact(data: any): Observable<any> {
    return this.api.post(environment.createContact, data);
  }

  updateContact(data: any): Observable<any> {
    return this.api.post(environment.updateContact, data);
  }

  createContactField(data: any): Observable<any> {
    return this.api.post(environment.createContactField, data);
  }

  getContactFields(data: any): Observable<any> {
    return this.api.post(environment.getContactField, data);
  }

  deleteContactField(data: any): Observable<any> {
    return this.api.post(environment.deleteContactField, data);
  }

  updateContactField(data: any): Observable<any> {
    return this.api.post(environment.updateContactField, data);
  }

  createBulkContact(data: any): Observable<any> {
    return this.api.post(environment.createBulkContact, data);
  }

  getAllContact(data: any): Observable<any> {
    return this.api.post(environment.getAllContact, data);
  }
}

